// Chamadas de áudio e vídeo (0.35), de app para app, a dois ou em grupo (sala de aula, família...).
// O vídeo passa pelo LiveKit; a função "chamada" do servidor confere quem está na conversa e entrega a chave da sala.
import { NativeModules, Platform, TurboModuleRegistry } from 'react-native';
import { router } from 'expo-router';
import { supabase } from './supabase';
import { DEMO } from './env';
import { t } from './i18n';
import { pararDeTocar } from './chat';

export type Sala = { url: string; token: string; id: string; sala: string; tipo: 'audio' | 'video'; nova: boolean };
const nativo = (n: string) => !!((NativeModules as any)[n] ?? TurboModuleRegistry.get?.(n));

/** O app instalado tem o módulo de vídeo? (APK/iPhone 0.35 ou mais novo; no navegador sempre tem) */
export const chamadaDisponivel = () => Platform.OS === 'web' || (nativo('WebRTCModule') && nativo('LivekitReactNativeModule'));

export async function pedirSala(conversa: string, tipo: 'audio' | 'video'): Promise<Sala> {
  if (DEMO) throw new Error(t('Na prévia de demonstração não há chamadas de verdade.'));
  if (!supabase) throw new Error(t('Servidor não configurado.'));
  const { data, error } = await supabase.functions.invoke('chamada', { body: { conversa, tipo } });
  if (error) {
    let msg = String(error.message ?? error);
    try { const c = await (error as any).context?.json?.(); if (c?.erro) msg = c.codigo === 'sem-livekit' ? t('As chamadas ainda não foram ligadas no servidor (17-LIGAR-MENSAGENS.bat).') : c.erro; } catch { /* segue */ }
    if (/not found|404/i.test(msg)) msg = t('As chamadas ainda não foram ligadas no servidor (17-LIGAR-MENSAGENS.bat).');
    throw new Error(msg);
  }
  return data as Sala;
}

/** Mensagem clara quando o LiveKit recusa a conexão (chave do servidor errada ou apagada). */
export function erroDaSala(e: unknown) {
  const m = String((e as any)?.message ?? e ?? '');
  if (/invalid token|unauthori[sz]ed|401|token is expired|signature/i.test(m))
    return t('O servidor de chamadas recusou a chave do LiveKit. No computador do administrador, rode o 30-CONSERTAR-CHAMADAS.bat.');
  if (/could not establish|failed to fetch|network|timeout/i.test(m))
    return t('Não consegui conectar a chamada. Confira a internet e tente de novo.') + ' (' + m.slice(0, 120) + ')';
  return m;
}

/** Texto 24 (4c): ao sair da chamada, o servidor guarda a duração real na reunião marcada do escritório (se houver). */
export function avisarFimDaChamada(id: string) {
  if (DEMO || !supabase) return;
  supabase.rpc('escritorio_reuniao_fim', { p_chamada: id }).then(() => {}, () => {});
}

export async function encerrarNoServidor(id: string) {
  if (DEMO || !supabase) return;
  await supabase.rpc('chamada_encerrar', { p_chamada: id }).then(() => {}, () => {});
}

/** Abre a tela da chamada (quem liga e quem atende usam o mesmo caminho). */
export function abrirChamada(conversa: string, tipo: 'audio' | 'video', nome: string) {
  pararDeTocar();
  router.push({ pathname: '/chamada', params: { conversa, tipo, nome } } as any);
}
